
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'StoreLink',
	props: {
		link: String,
	},
});
